import React from 'react'

export default function WorkoutTitleSection({
  children,
}: {
  children: ReactNode,
}) {
  return <h4 className="training--format text--caps">{children}</h4>
}
